










































































































































































































import { FRadioGroup, FRadioGroupField, FMessageBox, FFormStep, FIcon, FLabel } from '@fkui/vue';
import Vue from 'vue';
import { ValidationService, ValidatorName } from '@fkui/logic';
import BtTillgangarSkulderContent from '@/components/BtTillgangarSkulderContent.vue';
import { EventBus } from '@/services/MainService/event-bus';
import BtNumberField from './BtNumberField.vue';
import FkRichtext from 'fk-vue-richtext';

export default Vue.extend({
    name: 'BtTillgangarSkulder',
    components: {
        FRadioGroup,
        FRadioGroupField,
        FMessageBox,
        FFormStep,
        FIcon,
        FLabel,
        BtTillgangarSkulderContent,
        BtNumberField,
        FkRichtext,
    },
    props: {
        dataArray: {
            type: Object,
            default: () => {
                return [] as string[];
            },
        },
    },
    data() {
        return {
            id: 'btTillgangarSkulder',
            isSambo: false,
            propertyChoose: '',
            hasOver100k: '',
            realEstateValueAccountEnsam: '',
            realEstateValuePaperEnsam: '',
            realEstateValueOtherEnsam: '',
            realEstateValueLiabilitiesEnsam: '',
            realEstateValueAccountSambo: '',
            realEstateValuePaperSambo: '',
            realEstateValueOtherSambo: '',
            realEstateValueLiabilitiesSambo: '',
            taxeringsvarde: '',
            validation: {
                number: {
                    required: { errorMessage: this.$t('SBRV.RW.pengarfalt.etikett.fyllipengarfalt') },
                    minValue: { minValue: 1 },
                    maxValue: { maxValue: 99999999 },
                },
            },
        };
    },
    watch: {
        propertyChoose: function () {
            this.$nextTick(this.toggleErrorMessages);
        },
    },
    created() {
        this.registerValidators();
    },
    mounted() {
        EventBus.$on('sambo-radio', this.samboClickHandler);
        this.registerValidators();
    },
    methods: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        openContainer(toggleIsOpen: any): void {
            this.$emit('on-change-emit-tillgangar');
            toggleIsOpen();
        },
        onChange() {
            this.onSubmitStep();
            this.$emit('on-change-emit-tillgangar');
        },
        samboClickHandler(selection: boolean): void {
            this.isSambo = !selection;
            this.onSubmitStep();
        },
        registerValidators() {
            ValidationService.registerValidator({
                name: 'custom' as ValidatorName,
                validation: () => {
                    this.$nextTick(this.toggleErrorMessages);
                    return this.propertyChoose !== 'has-condominium-yes';
                },
            });
        },
        toggleErrorMessages(): void {
            const errorList = this.$el.querySelector('.form-step__error') as HTMLElement;
            const errorIcon = this.$el.querySelector('#bostad-utover .label__message--error') as HTMLElement;
            if (errorList) {
                if (this.propertyChoose === 'has-condominium-yes') {
                    errorList.style.display = 'none';
                    // eslint-disable-next-line max-depth
                    if (errorIcon) errorIcon.style.display = 'none';
                } else {
                    errorList.style.display = 'block';
                    // eslint-disable-next-line max-depth
                    if (errorIcon) errorIcon.style.display = 'block';
                }
            }

            const interval = setInterval(() => {
                const errorList = this.$el.querySelector('.form-step__error') as HTMLElement;
                const errorIcon = this.$el.querySelector('#bostad-utover .label__message--error') as HTMLElement;
                if (errorList) {
                    clearInterval(interval);
                    if (this.propertyChoose === 'has-condominium-yes') {
                        errorList.style.display = 'none';
                        // eslint-disable-next-line max-depth
                        if (errorIcon) errorIcon.style.display = 'none';
                    } else {
                        errorList.style.display = 'block';
                        // eslint-disable-next-line max-depth
                        if (errorIcon) errorIcon.style.display = 'block';
                    }
                } else if (this.propertyChoose !== 'has-condominium-yes') {
                    clearInterval(interval);
                }
            }, 100);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onEmitEnsam(data: any) {
            this.realEstateValueAccountEnsam = data.realEstateValueAccount;
            this.realEstateValuePaperEnsam = data.realEstateValuePaper;
            this.realEstateValueOtherEnsam = data.realEstateValueOther;
            this.realEstateValueLiabilitiesEnsam = data.realEstateValueLiabilities;
            this.onChange();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onEmitSambo(data: any) {
            this.realEstateValueAccountSambo = data.realEstateValueAccount;
            this.realEstateValuePaperSambo = data.realEstateValuePaper;
            this.realEstateValueOtherSambo = data.realEstateValueOther;
            this.realEstateValueLiabilitiesSambo = data.realEstateValueLiabilities;
            this.onChange();
        },
        onSubmitStep() {
            ValidationService.validateAllElements('btTillgangarSkulder');
            const dataArray = {
                ensam: [],
                sambo: [],
            };

            dataArray.ensam = this.addEnsamData();
            if (this.isSambo) {
                dataArray.sambo = this.addSamboData();
            }
            this.$root.$emit('on-submit-emit-tillgangar', dataArray, 'btTillgangarSkulder');
            this.$emit('on-submit-emit-tillgangar', dataArray, 'btTillgangarSkulder');
        },
        // eslint-disable-next-line complexity,@typescript-eslint/no-explicit-any
        addEnsamData(): any {
            const dataArray = [];

            if (this.propertyChoose === 'has-assets-no') {
                dataArray.push({
                    itemId: 'agerFlerFastigheterEnsamboende',
                    label: this.isSambo
                        ? this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.sammanboende')
                        : this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.ensamboende'),
                    value: this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.nej'),
                });
            } else if (this.propertyChoose === 'has-real-estate-yes') {
                dataArray.push(
                    {
                        itemId: 'agerFlerFastigheterEnsamboende',
                        label: this.isSambo
                            ? this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.sammanboende')
                            : this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.ensamboende'),
                        value: this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.agerflerfastigheter.jafastighet'),
                    },
                    {
                        itemId: 'taxeringsvarde',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.taxeringsvarde'),
                        value: this.taxeringsvarde,
                    },
                );
            }
            if (
                (this.hasOver100k === 'has-over-100k-yes' || this.propertyChoose === 'has-real-estate-yes') &&
                this.propertyChoose !== 'has-condominium-yes'
            ) {
                if (this.hasOver100k === 'has-over-100k-yes' && this.propertyChoose !== 'has-real-estate-yes') {
                    dataArray.push({
                        itemId: 'tillgangarOvergransEnsamboende',
                        label: this.isSambo
                            ? this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.tillgangarovergrans.sammanboende')
                            : this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.tillgangarovergrans.ensamboende'),
                        value: 'Ja',
                    });
                }
                if (this.realEstateValueAccountEnsam) {
                    dataArray.push({
                        itemId: 'kontoEnsamboende',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.konto'),
                        value: this.realEstateValueAccountEnsam,
                    });
                }
                if (this.realEstateValuePaperEnsam) {
                    dataArray.push({
                        itemId: 'vardepapperEnsamboende',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.vardepapper'),
                        value: this.realEstateValuePaperEnsam,
                    });
                }
                if (this.realEstateValueOtherEnsam) {
                    dataArray.push({
                        itemId: 'ovrigaTillgangarEnsamboende',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.ovrigatillgangar'),
                        value: this.realEstateValueOtherEnsam,
                    });
                }
                if (this.realEstateValueLiabilitiesEnsam) {
                    dataArray.push({
                        itemId: 'skulderEnsamboende',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.skulder'),
                        value: this.realEstateValueLiabilitiesEnsam,
                    });
                }
            } else if (this.hasOver100k === 'has-over-100k-no') {
                dataArray.push({
                    itemId: 'tillgangarOvergransEnsamboende',
                    label: this.isSambo
                        ? this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.tillgangarovergrans.sammanboende')
                        : this.$t('btp.preliminar.berakning.tillgangarskulder.etikett.tillgangarovergrans.ensamboende'),
                    value: 'Nej',
                });
            }
            return dataArray;
        },
        // eslint-disable-next-line complexity,@typescript-eslint/no-explicit-any
        addSamboData(): any {
            const dataArray = [];

            if (
                (this.hasOver100k === 'has-over-100k-yes' || this.propertyChoose === 'has-real-estate-yes') &&
                this.propertyChoose !== 'has-condominium-yes'
            ) {
                if (this.realEstateValueAccountSambo) {
                    dataArray.push({
                        itemId: 'kontoSambo',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.konto'),
                        value: this.realEstateValueAccountSambo,
                    });
                }
                if (this.realEstateValuePaperSambo) {
                    dataArray.push({
                        itemId: 'vardepapperSambo',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.vardepapper'),
                        value: this.realEstateValuePaperSambo,
                    });
                }
                if (this.realEstateValueOtherSambo) {
                    dataArray.push({
                        itemId: 'ovrigaTillgangarSambo',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.ovrigatillgangar'),
                        value: this.realEstateValueOtherSambo,
                    });
                }
                if (this.realEstateValueLiabilitiesSambo) {
                    dataArray.push({
                        itemId: 'skulderSambo',
                        label: this.$t('btp.preliminar.berakning.tillgangarskulder.info.skulder'),
                        value: this.realEstateValueLiabilitiesSambo,
                    });
                }
            }
            return dataArray;
        },
    },
});
